/**
 * @Date: 2020-06-01 14:02
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 */
export const getDefaultProps = (componentProps, vm) => {
  const props = Object.keys(componentProps).reduce((pre, cur) => {
    const stash = {}
    if (vm[cur]) {
      stash[cur] = vm[cur]
    }
    return {
      ...pre,
      ...stash
    }
  }, {})
  return props
}

/**
 * 获取上传文件的名称
 * @param fileName
 * @param oriFileName
 * @returns {string}
 */
export const fixFileSuffix = (fileName, oriFileName) => {
  const suffix = oriFileName.substring(oriFileName.lastIndexOf('.'))
  if (fileName.includes('.')) {
    fileName = fileName.substring(0, fileName.lastIndexOf('.')) + suffix
  } else {
    fileName = fileName + suffix
  }
  return fileName
}
